import { useSetupMFATOTP as useSetupMFATOTPFlow } from 'mfa'
import prepareTOTPRegistration from '../api/prepareTOTPRegistration'
import finishTOTPRegistration from '../api/finishTOTPRegistration'
import { apiRequest } from '../utils/apiRequest'

export const useSetupMFATOTP = ({ isFromSettings = false } = {}) =>
  useSetupMFATOTPFlow({
    isFromSettings,
    prepareRegistration: () => apiRequest(prepareTOTPRegistration),
    finishRegistration: (data) => apiRequest(finishTOTPRegistration, data),
  })
